import { Box, HStack, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { DARK_SURFACE_GRADIENT, DARK_TABLE_BORDER, AUTH_MOBILE_BUTTON_GRADIENT, AUTH_MOBILE_BUTTON_GRADIENT_HOVER } from 'constants/dark-tokens'
import routes from 'routes'

/**
 * Dashboard "Complete your profile" nudge card.
 * Shown only when the active athlete profile is unpublished/incomplete.
 * Mockup: imgs 75–76 — surface-gradient card, purple person icon, gradient "Set Up Now" pill.
 */
const CompleteProfileCard = () => {
  const navigate = useNavigate()

  return (
    <Box
      bg={DARK_SURFACE_GRADIENT}
      border={`1px solid ${DARK_TABLE_BORDER}`}
      borderRadius="16px"
      px="16px"
      py="14px"
    >
      <HStack spacing="12px" align="center">
        {/* Purple person icon */}
        <Box
          width="40px"
          height="40px"
          borderRadius="full"
          bg="rgba(128, 90, 213, 0.18)"
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexShrink={0}
        >
          {/* Person silhouette SVG — inline to avoid asset dependency */}
          <Box as="svg" width="22px" height="22px" viewBox="0 0 24 24" fill="none">
            <Box
              as="path"
              d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z"
              fill="#9D71FF"
            />
          </Box>
        </Box>

        {/* Text block */}
        <Box flex={1} minW={0}>
          <Text
            color="white"
            fontSize="14px"
            fontWeight={700}
            m={0}
            lineHeight="20px"
          >
            Complete your profile
          </Text>
          <Text
            color="rgba(255,255,255,0.55)"
            fontSize="12px"
            fontWeight={400}
            m={0}
            lineHeight="16px"
            mt="2px"
          >
            Coaches can&apos;t find or invite you until your profile is set up.
          </Text>
        </Box>

        {/* Set Up Now pill */}
        <Box
          as="button"
          type="button"
          onClick={() => navigate(routes.editProfile.value)}
          flexShrink={0}
          px="14px"
          py="8px"
          borderRadius="full"
          bg={AUTH_MOBILE_BUTTON_GRADIENT}
          color="white"
          fontSize="12px"
          fontWeight={600}
          letterSpacing="0.02em"
          whiteSpace="nowrap"
          border="none"
          outline="none"
          cursor="pointer"
          _hover={{ background: AUTH_MOBILE_BUTTON_GRADIENT_HOVER }}
          _focus={{ boxShadow: 'none', outline: 'none' }}
          _focusVisible={{ boxShadow: 'none', outline: 'none' }}
          _active={{ opacity: 0.85 }}
          style={{ WebkitTapHighlightColor: 'transparent' }}
          transition="background 0.15s, opacity 0.15s"
        >
          Set Up Now
        </Box>
      </HStack>
    </Box>
  )
}

export default CompleteProfileCard
